import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../util/reactIntl';

import IconCollection from '../IconCollection/IconCollection';

import css from './ShareListingButton.module.css';

/**
 * Shares the current page URL (native share when available, otherwise clipboard).
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Additional class names for the button element
 * @returns {JSX.Element}
 */
const ShareListingButton = props => {
  const { className } = props;
  const intl = useIntl();

  const handleShare = async e => {
    e.preventDefault();
    if (typeof window === 'undefined') {
      return;
    }
    const url = window.location.href;
    try {
      if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        await navigator.share({ url });
        return;
      }
      if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      }
    } catch (err) {
      if (err?.name === 'AbortError') {
        return;
      }
    }
  };

  return (
    <button
      type="button"
      className={classNames(css.root, className)}
      onClick={handleShare}
      aria-label={intl.formatMessage({ id: 'ShareButton.aria' })}
    >
      <IconCollection name="share" />
      <span className={css.label}>
        <FormattedMessage id="ShareButton.label" />
      </span>
    </button>
  );
};

export default ShareListingButton;
